import myhttp from "./index.js";

export default {
  getUnregisteredTaxons() {
    return myhttp().get("api/unregistered-taxons/");
  },
};
